import React, { useState, useEffect }  from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'
import { useParams } from 'react-router-dom';
import axios from "axios";
import Loader from '../components/Loader'
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";

const SuccessStoryDetails = () => {
  let { slug } = useParams();
  const [loading, setLoading] = useState(true);  
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const siteUrl = process.env.REACT_APP_BACKEND_URL;
  
  const [data, setData] = useState('')
  const [storyImage, setStoryImage] = useState([])
  const apiUrl = apiBaseUrl+`casestudy/details/${slug}`;  

  const fetchInfo = () => {
    return axios.get(apiUrl).then((res) => {
      setData(res.data.case)
      setStoryImage(res.data.images)
      //console.log(res.data.case);
      //console.log(res.data.images);
    });
  };

  useEffect(() => {
    setTimeout(() => {
      fetchInfo()
        setLoading(false);
    }, 2000);
  }, []);

  function createMarkup(data) {
    return { __html: data };
  }

  {/*
  const story_images1 = [
    {
      original: "/images/story1.jpg",
      thumbnail: "/images/story1.jpg",
    },
    {
      original: "/images/story1-1.jpg",
      thumbnail: "/images/story1-1.jpg",
    },
    {
      original: "/images/story1-2.jpg",
      thumbnail: "/images/story1-2.jpg",
    },
    {
      original: "/images/story1-3.jpg",
      thumbnail: "/images/story1-3.jpg",
    },
    {
      original: "/images/story1-4.jpg",
      thumbnail: "/images/story1-4.jpg",
    }, 
    {
      original: "/images/story1-5.jpg",
      thumbnail: "/images/story1-5.jpg",
    },            
  ];

  const story_images2 = [
    {
      original: "/images/story2.jpg",
      thumbnail: "/images/story2.jpg",
    },
    {
      original: "/images/story2-1.jpg",
      thumbnail: "/images/story2-1.jpg",
    },
  ];
  
  const story_images3 = [
    {
      original: "/images/story3.jpg",
      thumbnail: "/images/story3.jpg",
    },
    {
      original: "/images/story3-1.jpg",
      thumbnail: "/images/story3-1.jpg",
    },
  ];
  
  const story_images4 = [
    {
      original: "/images/story4.jpg",
      thumbnail: "/images/story4.jpg",
    },
    {
      original: "/images/story4-1.jpg",
      thumbnail: "/images/story4-1.jpg",
    },

  ];  
*/ }


  return (
    <>
    <Header/>

    { loading && (<Loader /> )}
    <section className="section-content-block">
      <div className="container">

        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 text-center">                       
            <div className="about-us-intro">
              <p className="blue">{data?.case_type}</p> 
              <h2 className="heading">Case Study: {data?.name}</h2>
              <p>{data?.short_description}</p>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 text-center">                       
            <div class="Products story-banner">
              {data?.image && (
                <img src={`${siteUrl}${data?.image}`} alt={data?.name} /> 
              )}

            </div>                            
          </div> 
        </div>        

        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 px-50">   
            <div className="Products case-des">
              <div dangerouslySetInnerHTML={createMarkup(data.description)} />
            </div>   
          </div> 
        </div>

        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 px-50 gallery-wrapper">   
            <ImageGallery items={storyImage} autoPlay={true} showPlayButton={false} showFullscreenButton={false} />
          </div>
        </div>


      </div> 
    </section>
      
    <Footer/>
    </>

  )
}

export default SuccessStoryDetails